class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
  
    if (!entries.some(entry => entry.isIntersecting)) return;
    observer.unobserve(this);
    // 当前的国家
    const local_code = this.dataset.localCode;
    // 要过滤的标签
    const invalidTags = ['hidden', 'gift', 'gift only'];

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {

        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');


        if (recommendations && recommendations.innerHTML.trim().length) {
          const liItems = Array.from(recommendations.querySelectorAll('.mini-cart__navigation > li')); // 获取<li>
          const visibleLiItems = liItems.filter(li => {
            const tagsAttr = li.dataset.customTag || '';
            const tags = tagsAttr.split(',').map(tag => tag.trim());
            // 去掉Worry-Free Purchase的推荐
            const title = li.querySelector('a.product-title')?.textContent.trim();
            return title != 'Worry-Free Purchase' && this.isValid(tags, invalidTags, local_code); 
          });

          let finalLiItems = visibleLiItems.length >= 4 ? visibleLiItems.slice(0, 4) : visibleLiItems;

          if (finalLiItems.length < 4) {
            const fallbackTpl = document.querySelector('#cart-fallback-recommendations');
            if (fallbackTpl) {
              const fallbackItems = Array.from(fallbackTpl.content.querySelectorAll('li'));
              const needed = 4 - finalLiItems.length;

              // 防止重复，过滤掉已有的商品（title 判重）
              const existingUrls = finalLiItems.map(li => li.querySelector('a.product-title')?.textContent.trim());
              const uniqueFallbacks = fallbackItems.filter(fallback => {
                const url = fallback.querySelector('a.product-title')?.textContent.trim();

                return url && !existingUrls.includes(url) && url;
              });

              

              finalLiItems = finalLiItems.concat(uniqueFallbacks.slice(0, needed));
            }
          }

          const ul = recommendations.querySelector('.mini-cart__navigation'); // 获取<ul>
          ul.innerHTML = '';
          finalLiItems.forEach(li => ul.appendChild(li));

          this.innerHTML = recommendations.innerHTML;
          //---data-track start
          document.dispatchEvent(new CustomEvent('cart-recommendations:fetch'));
          //---data-track end
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  isValid(tags, invalidTags, local_code) {
    // 1. 检查是否包含无效标签： 如果 tags 中包含任意一个 invalidTags 元素，就返回 false
    if (invalidTags.some(tag => tags.includes(tag))) {
        return false;
    }

    // 2. 按地区判断
    const hasUS = tags.includes('US');
    const hasEU = tags.includes('EU');
    if (local_code === 'US') {
        return hasUS || (!hasUS && !hasEU) || (hasUS && hasEU);
    } else {
        return hasEU || (!hasUS && !hasEU) || (hasUS && hasEU);
    }
  }
}
customElements.define('cart-recommendations', CartRecommendations);